import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type BadgeReward } from 'types/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiError } from 'openapi-typescript-fetch'

interface UsePutBadgeRewardProps {
  id: number
  onSuccess?: (data: BadgeReward, variables: BadgeReward) => void
  onError?: (error: ApiError, variables: BadgeReward) => void
}

export const usePutBadgeReward = ({
  id,
  onSuccess,
  onError,
}: UsePutBadgeRewardProps) => {
  const put = useTypedApiClient({
    path: '/admin/badgerewards/{id}',
    method: 'put',
  })
  const queryClient = useQueryClient()

  return useMutation<any, ApiError, BadgeReward>({
    mutationFn: async (data: BadgeReward) => {
      const response = await put({ ...data, id })
      return response.data
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/badgerewards/{id}', id],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
